import axios from "axios";

const send_form = () => ({
    formType: '',
    formData: {},
    loading: false,
    submitted: false, // = after successful submit
    error: false,
    errorMessage: '',
    form: {
        ['@submit']() {
            this.$event.preventDefault();
            this.error = false;
            this.errorMessage = '';

            if (this.loading) {
                return;
            }
            this.loading = true;

            axios.post('/wp-json/ilj-theme/v1/form/submit', { type: this.formType, ...this.formData }, {
                headers: {
                    'content-type': 'application/json',
                    'X-WP-Nonce': this.formData.nonce
                }
            })
                .then(res => {
                    if (res.status === 200) {
                        this.loading = false;
                        this.submitted = true;
                        return;
                    }
                })
                .catch(e => {
                    if (e.response) {
                        this.errorMessage = e.response.data.message;
                    }
                    this.error = true;
                    this.loading = false;
                });
        }
    }
});

export default send_form;